










import { FormFieldValidation } from '@/mixins/formValidation';
import Vue from 'vue';

export default Vue.extend({
  name: 'MStoreForm',
  mixins: [FormFieldValidation],
  props: {
    autocomplete: {
      type: String,
      default: 'off'
    },
    id: {
      type: String
    },
    dataVvScope: {
      type: String
    },
    resetValidationOnSubmit: {
      type: Boolean,
      default: false
    },
    preventUpdateOfApplicationDirty: {
      type: Boolean,
      default: false
    },
    updateApplicationDirtyOnModal: {
      type: Boolean,
      default: false
    },
    formClass: {
      type: String
    },
    formNoValidate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async onSubmit(this: any, event: any, reset: any) {
      const valid = await this.$refs.ValidationObserver.validate();
      if (!valid) {
        FormFieldValidation.methods.setFocusOnInvalidField(this);
        return;
      }
      this.$emit('submit', event);
      if (this.resetValidationOnSubmit) {
        reset();
      }
    }
  },
  mounted(this: any) {
    this.$watch(
      () => {
        return (this.$refs.ValidationObserver as any).ctx.dirty;
      },
      (dirty: boolean) => {
        this.$emit('formDirty', dirty);
        if (this.updateApplicationDirtyOnModal) {
          this.setApplicationDirtyOnModal(dirty);
        }
        if (this.preventUpdateOfApplicationDirty) {
          return;
        }
        this.setApplicationDirty(dirty);
      }
    );
  }
});
